module.exports = __webpack_public_path__ + "img/work_c.b102ed89.png";